import { environment } from "@/environments/environment";

export class ConfigurationServices {
  static GetIdentityUrl() {
    return environment.identityUrl;
  }

  static GetJdyUrl() {
    return environment.apiUrl;
  }
}


// WEBPACK FOOTER //
// ./src/common/configuration-services.js